import Image from 'next/image';
import styles from './ProsAndCons.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
export const ProsAndCons = ({
  index,
  productBasicInfoList
}: {
  index: number;
  productBasicInfoList: any[];
}) => {
  return <div className={styles.prosConsContainerFooter} data-sentry-component="ProsAndCons" data-sentry-source-file="ProsAndCons.tsx">
                            <div className={styles.prosConsContainer}>
                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-row items-center">
                                        <FontAwesomeIcon icon={faThumbsUp} className="text-green-500 mr-2 text-sm font-bold w-[15px] h-[15px]" data-sentry-element="FontAwesomeIcon" data-sentry-source-file="ProsAndCons.tsx" />
                                        <h3 className={styles.prosConsTitle}>Pros</h3>
                                    </div>
                                    <p className="text-[15px] leading-5">
                                        {productBasicInfoList[index]?.pros}
                                    </p>
                                </div>
                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-row items-center">
                                        <FontAwesomeIcon icon={faThumbsDown} className="text-red-500 mr-2 text-sm font-bold w-[15px] h-[15px]" data-sentry-element="FontAwesomeIcon" data-sentry-source-file="ProsAndCons.tsx" />
                                        <h3 className={styles.prosConsTitle}>Cons</h3>
                                    </div>
                                    <p className="text-[15px] leading-5">
                                        {productBasicInfoList[index]?.cons}
                                    </p>
                                </div>
                            </div>
                            <div className={styles.resourcesGroupFooter}>
                                <p className={styles.resourcesText}>Powered by AI. Resources:</p>
                                <div className={styles.resourcesImgGroup}>
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/amazon.png" alt="amazon" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="ProsAndCons.tsx" />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/google.png" alt="google" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="ProsAndCons.tsx" />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/reddit.png" alt="reddit" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="ProsAndCons.tsx" />
                                    <Image className={styles.recommendedLogo} src="/resourcesIcon/ebay.png" alt="ebay" width={20} height={20} data-sentry-element="Image" data-sentry-source-file="ProsAndCons.tsx" />
                                </div>
                            </div>
                        </div>;
};